import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export class Contract {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  description!: string;
  @IsString()
  @Expose()
  number!: string;
  @IsString()
  @Expose()
  contractorName!: string;
}

export class ContractResponse extends GenericTableResponse<Contract> {
  @Type(() => Contract)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Contract>;
}
